import { basicTask, convertImgToSvg, isSvgFile } from "./task";
import { swiperInit } from "./swiper";
import { animate, createSpring, createTimeline, stagger, utils } from "animejs";
const bodyWrap = document.body;
import { initRadialFeature } from "./circle";
const sideNav = document.querySelector(".sidenav-group");
const hamburger = document.querySelector(".hamburger");
const menuMobile = document.querySelector(".mobile-nav-wrap");
const searchWrap = document.querySelector(".searchbox");
gsap.registerPlugin(ScrollTrigger);

window.DEBUG_FP_SCROLL = true;
window._fpScrollDebug = {
	lastLeaveAt: 0,
	wheels: {
		inactive: 0,
		locked: 0,
		delay: 0,
		leaveDown: 0,
		leaveUp: 0,
		scrub: 0,
	},
};
window.fpScrollDebug = function (tag, data) {
	if (!window.DEBUG_FP_SCROLL) return;
	console.log(
		`%c[fp-scroll] ${tag}`,
		"color:#94C104;font-weight:700",
		data || "",
	);
};

let resizeTimeout;
let lastIsMobile = window.innerWidth <= 1200.1;
function introDone() {
	window.introFinished = true;

	const currentSlide =
		window.primarySwiper.slides[window.primarySwiper.activeIndex];

	triggerFadeUp(currentSlide);
}

try {
	document.querySelectorAll(".text-fd-up").forEach((el) => {
		const words = el.textContent.trim().split(/\s+/);

		el.innerHTML = words
			.map(
				(word, i) => `<span class="word" style="--i:${i}">${word}&nbsp;</span>`,
			)
			.join("");
	});

	window.introFinished = false;
} catch (error) { }
try {
	const normalScrollContainers = document.querySelectorAll(
		".normal-scroll-content",
	);

	normalScrollContainers.forEach((container) => {
		container.addEventListener("scroll", () => {
			// Correct ScrollReveal method to refresh positions manually
			if (typeof ScrollReveal !== "undefined") {
				ScrollReveal().delegate();
			}
		});
	});
} catch (error) { }
document.addEventListener("DOMContentLoaded", function () {
	generateSVG();
	try {
		mappingFunc();
	} catch (error) { }

	try {
		const introSpan = utils.$(".intro span");
		const logos = ["logo-fill", "logo-stroke"];
		console.log(logos);
		let loadedLogo = [];
		$("body").on("generate-svg", function (e) {
			const { element } = e.detail;
			const isIntroLogo = element.closest(".intro");
			if (!isIntroLogo) return;
			loadedLogo.push(element);
			if (loadedLogo.length === logos.length) {
				runAnimation();
			}
		});
		function runAnimation() {
			const fillLogo = loadedLogo.find((el) =>
				el.dataset.src.includes(logos[0]),
			);
			const strokeLogo = loadedLogo.find((el) =>
				el.dataset.src.includes(logos[1]),
			);
			utils.set(strokeLogo, {
				opacity: 1,
			});
			loadedLogo.forEach((element) => {
				const isFillLogo = element.dataset.src.includes(logos[0]);
				const isStrokeLogo = element.dataset.src.includes(logos[1]);
				const tl = createTimeline({
					autoplay: false,
					onComplete: () => {
						const newTl = createTimeline({
							autoplay: false,
							onComplete: () => {
								$(".intro").fadeOut(500, function () {
									// $(".intro").remove();
									introDone();
								});
							},
						});
						newTl.add(fillLogo, {
							opacity: 1,
						});
						newTl.add(
							fillLogo,
							{
								opacity: 0,
							},
							"<",
						);
						newTl.add(
							strokeLogo,
							{
								opacity: 0,
							},
							"<<",
						);
						introSpan.forEach((span, index) => {
							newTl.add(
								span,
								{
									// opacity: [1, 0],
									duration: 800,
									ease: "easeInOutSine",
									x: [0, index % 2 === 0 ? "100%" : "-100%"],
								},
								"<<",
							);
						});
						setTimeout(() => {
							newTl.play();
						}, 300);
					},
				});

				if (isStrokeLogo) {
					const paths = element.querySelectorAll("path");
					paths.forEach((path, index) => {
						const hasMask = path.getAttribute("mask");
						const reverseIndex = paths.length - index - 1;
						path.setAttribute("initial-color", path.getAttribute("fill"));
						// path.removeAttribute("fill");
						const strokeDashArray = path.getAttribute("stroke-dasharray")
							? Number(path.getAttribute("stroke-dasharray"))
							: 0;
						utils.set(path, {
							strokeDashoffset: parseInt(strokeDashArray),
							strokeDasharray: parseInt(strokeDashArray),
						});
						let animation = {
							strokeDashoffset: 0,
						};
						if (hasMask) {
							utils.set(path, { opacity: 0 });
							delete animation.strokeDashoffset;
							animation.opacity = 1;
						}
						tl.add(
							path,
							{
								duration: 1000,
								ease: "inQuart",
								...animation,
							},
							"<<",
						);
					});
				}

				tl.play();
			});
		}
	} catch (error) { }

	const tiltElements = document.querySelectorAll(".js-tilt-node");

	VanillaTilt.init(tiltElements, {
		max: 15, // Max tilt rotation (degrees)
		speed: 400, // Speed of the enter/exit transition
		perspective: 1000, // Transform perspective (lower = more extreme)
		scale: 1.05, // Scale on hover
		gyroscope: true, // Device orientation support
		"full-page-listening": false,
		"mouse-event-element": null,
		reset: true, // Reset the tilt on mouseleave
		easing: "cubic-bezier(.03,.98,.52,.99)", // Easing on enter/exit
	});

	try {
		const images = document.querySelectorAll(".tab-item-hover img");

		images.forEach((img) => {
			const src = img.getAttribute("src");

			if (!src) return;

			const preload = new Image();
			preload.src = src;
		});
	} catch (error) { }
});

document.addEventListener("DOMContentLoaded", () => {
	try {
		swiperInit();
	} catch (error) { }

	basicTask();
	lozadInit();
	try {
		if ($(window).width() > 1200.1) {
			fullPageInit();
		}
		aosInit();
	} catch (error) { }
	generalFunction.init();
});

window.addEventListener(
	"resize",
	function () {
		clearTimeout(resizeTimeout);

		resizeTimeout = setTimeout(() => {
			const width = window.innerWidth;
			const isMobile = width <= 1200.1;

			// Only redo mapping when crossing the breakpoint.
			if (isMobile !== lastIsMobile) {
				try {
					mappingFunc();
				} catch (error) { }
				lastIsMobile = isMobile;
			}

			// Heavy work (ScrollReveal scan) should only run after resize "settles".
			if ("requestIdleCallback" in window) {
				window.requestIdleCallback(() => generalFunction.scrollReveal(), {
					timeout: 500,
				});
			} else {
				generalFunction.scrollReveal();
			}
		}, 200);
	},
	{ passive: true },
);
window.addEventListener("scroll", function () {
	const width = window.innerWidth;
	const scrollTop = window.scrollY || document.documentElement.scrollTop;
	if (
		document.body.scrollTop > 100 ||
		document.documentElement.scrollTop > 100
	) {
		bodyWrap.classList.add("minimize");
	} else {
		bodyWrap.classList.remove("minimize");
	}
	if (scrollTop > window.innerHeight) {
		sideNav?.classList.add("show");
	} else {
		sideNav?.classList.remove("show");
	}
});
document.addEventListener("click", (event) => {
	if (!event.target.closest(".search-toggle, .search-overlay")) {
		searchWrap?.classList.remove("is-open");
	}
	if (!event.target.closest(".mobile-nav-wrap, .site-menu-toggle")) {
		menuMobile?.classList.remove("is-open");
		bodyWrap.classList.remove("overlay-bg");
		hamburger?.classList.remove("is-active");
	}
});

try {
	if (typeof Fancybox !== "undefined") {
		Fancybox.bind("[data-fancybox]", {
			parentEl: document.body, // Element containing main structure
		});
	}
} catch (e) { }

const lazyLoader =
	typeof lozad !== "undefined"
		? lozad(".lozad", {
			rootMargin: "10px 0px", // syntax similar to that of CSS Margin
			threshold: 0.2, // ratio of element convergence
			enableAutoReload: true, // it will reload the new image when validating attributes changes
		})
		: null;

export function lozadInit() {
	if (!lazyLoader) return;
	lazyLoader.observe();
	window.lazyLoader = lazyLoader;
}

// Allow other modules to safely call this without circular imports
window.lozadInit = lozadInit;

function generateSVG() {
	var imageContainers = document.querySelectorAll(".image-svg");
	imageContainers.forEach(function (imageContainer) {
		// Find the img element within each container
		var images = imageContainer.querySelectorAll("img");
		images.forEach((img) => {
			convertImgToSvg(img);
		});
	});
}
const generalFunction = {
	svgVivus: () => {
		try {
			if (typeof gsap === "undefined") return;

			// 1. Target the parent container instead of individual paths first
			const container = document.querySelector("#map-lines");
			if (!container) return;

			const paths = container.querySelectorAll(".line-svg");
			if (!paths.length) return;

			// ── detect weak device once ──
			const isWeakDevice =
				navigator.hardwareConcurrency <= 4 ||
				/Android|iPhone|iPad/i.test(navigator.userAgent);

			const DRAW_DURATION = isWeakDevice ? 2 : 4;

			// Array to keep track of all generated timelines
			const timelines = [];

			paths.forEach((path, index) => {
				try {
					const d = path.getAttribute("d");
					if (!d) return;

					// Split into individual sub-paths (each starts with M or m)
					const subPaths = d.split(/(?=[Mm])/).map(s => s.trim()).filter(Boolean);

					if (subPaths && subPaths.length > 1) {
						// Create a group to hold the individual paths
						const g = document.createElementNS("http://www.w3.org/2000/svg", "g");

						// Copy classes and styles
						const className = path.getAttribute("class");
						if (className) g.setAttribute("class", className);

						const fill = path.getAttribute("fill");

						// Determine direction of dashes
						const headD = subPaths[0];
						const firstDashD = subPaths[1];
						const lastDashD = subPaths[subPaths.length - 1];

						const getStartPoint = (pathD) => {
							if (!pathD) return { x: 0, y: 0 };
							const match = pathD.match(/[Mm]\s*([-\d.]+)[,\s]*([-\d.]+)/);
							if (match) return { x: parseFloat(match[1]), y: parseFloat(match[2]) };
							return { x: 0, y: 0 };
						};

						const pHead = getStartPoint(headD);

						const dist = (p1, p2) => Math.hypot(p1.x - p2.x, p1.y - p2.y);

						// Separate the head (arrowhead) so it is guaranteed to be drawn last
						const head = subPaths.shift();

						// Sort the remaining dashes by their distance from the head (descending).
						// This perfectly interleaves parallel path sequences (if any) and ensures
						// they animate continuously from Tail to Head without jumping back.
						subPaths.sort((a, b) => {
							const pA = getStartPoint(a);
							const pB = getStartPoint(b);
							return dist(pB, pHead) - dist(pA, pHead);
						});

						// Put the head back at the end
						subPaths.push(head);

						const segments = [];

						subPaths.forEach(subD => {
							const p = document.createElementNS("http://www.w3.org/2000/svg", "path");
							p.setAttribute("d", subD);
							if (fill) p.setAttribute("fill", fill);

							p.style.opacity = 0;

							// Optional subtle glow
							if (!isWeakDevice) {
								p.style.filter = "drop-shadow(0 0 3px rgba(148,193,4,.6))";
							}

							p.style.willChange = "opacity";
							g.appendChild(p);
							segments.push(p);
						});

						const isReversed = path.classList.contains("reserve");
						if (isReversed) {
							segments.reverse();
						}

						// Replace the original path with the new group
						path.parentNode.replaceChild(g, path);

						// Create a timeline for this line
						const tl = gsap.timeline({
							repeat: -1,
							paused: true,
							repeatDelay: 0
						});

						// Enforce a fast, consistent speed so all lines look like solid moving shapes
						// (Shorter lines otherwise get huge staggers and look like blinking dots)
						const staggerTime = Math.min(0.06, DRAW_DURATION / segments.length);

						// Stagger reveal each segment to simulate advance
						tl.to(segments, {
							opacity: 1,
							duration: staggerTime * 2.5, // ensures smooth overlapping
							stagger: staggerTime,
							ease: "none",
							force3D: true
						})
							// After fully drawn, wait 0.4s then fade out the whole line and repeat
							.to(segments, {
								opacity: 0,
								duration: 0.8,
								ease: "power2.in",
								delay: 0.4,
								force3D: true
							});

						timelines.push(tl);
					} else {
						// Fallback for normal continuous paths
						const length = path.getTotalLength();
						if (!length) return;

						path.style.fill = "none";
						path.style.stroke = "#94C104";
						path.style.strokeWidth = isWeakDevice ? "1.5" : "2";
						path.style.strokeDasharray = length;

						if (!isWeakDevice) {
							path.style.filter = "drop-shadow(0 0 6px rgba(148,193,4,.8))";
						}

						path.style.willChange = "stroke-dashoffset, opacity";

						const isReversed = path.classList.contains("reserve");
						const startOffset = isReversed ? -length : length;
						const endOffset = isReversed ? -length * 2 : 0;

						// Timelines are created PAUSED
						const tl = gsap
							.timeline({
								repeat: -1,
								paused: true,
								repeatDelay: 0,
							})
							.fromTo(
								path,
								{
									strokeDashoffset: startOffset,
									opacity: 1,
								},
								{
									strokeDashoffset: endOffset,
									duration: DRAW_DURATION,
									ease: "none",
									force3D: true,
								},
							)
							.to(path, {
								opacity: 0,
								duration: 0.8,
								ease: "power2.in",
								delay: 0.4,
								force3D: true,
							});

						// Store reference to this path's timeline
						timelines.push(tl);
					}
				} catch (err) {
					console.error(`[Map Draw] path ${index} failed`, err);
				}
			});

			// 2. Single observer watching the entire container
			const observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							// Play all timelines when map comes into view
							timelines.forEach((tl) => tl.play());
						} else {
							// Pause all timelines instantly when map leaves view
							timelines.forEach((tl) => tl.pause());
						}
					});
				},
				{
					threshold: 0.05, // Triggers as soon as 5% of the map is visible
				},
			);

			// Start observing the container
			observer.observe(container);
		} catch (err) {
			console.error("[Map Draw] fatal", err);
		}
	},

	gsapFlower: () => {
		const $section = $(".home-branding-list");
		const $flowerContainer = $section.find(".container-flower");

		if (!$flowerContainer.length) return;

		// Prevent re-initialization on every generalFunction.init() call
		// (triggered by resize, including iOS Safari address-bar collapse)
		if ($flowerContainer[0].dataset.brandingInit) return;
		$flowerContainer[0].dataset.brandingInit = "1";

		const $droplets = $flowerContainer.find(".droplet-wrap");
		const $tabs = $section.find(".item-hover");

		let currentIndex = 0;
		let autoplayTimer = null;
		const intervalTime = 3000;
		let isIntroDone = false;
		let isAnimating = false;
		let isVisibleInViewport = false;

		gsap.set($droplets, {
			opacity: 0,
			scale: 0.01,
			rotation: 0,
			transformOrigin: "right bottom",
			pointerEvents: "none",
		});

		// Petals share a hub at each droplet's bottom-right corner (see flower.sass).
		// The container must rotate around that same point, not its box center.
		function getFlowerPivot() {
			const droplet = $droplets[0];
			if (!droplet) return "50% 50%";

			const style = getComputedStyle(droplet);
			const left = parseFloat(style.left) || 0;
			const top = parseFloat(style.top) || 0;

			return `${left + droplet.offsetWidth}px ${top + droplet.offsetHeight}px`;
		}

		function applyFlowerPivot() {
			const pivot = getFlowerPivot();
			$flowerContainer[0].style.setProperty("--flower-pivot", pivot);
			gsap.set($flowerContainer[0], { transformOrigin: pivot });
		}

		applyFlowerPivot();

		let pivotResizeTimer;
		window.addEventListener(
			"resize",
			() => {
				clearTimeout(pivotResizeTimer);
				pivotResizeTimer = setTimeout(applyFlowerPivot, 200);
			},
			{ passive: true },
		);

		function getRotation(el) {
			const rot = getComputedStyle(el).getPropertyValue("--rot");
			return parseFloat(rot);
		}

		function setActive(index) {
			currentIndex = index;

			const $current = $droplets.eq(index);
			const targetType = $current.data("type");

			$droplets.removeClass("is-active");
			$current.addClass("is-active");

			$tabs.removeClass("is-active").hide();

			const $activeTab = $tabs.filter(`.${targetType}`);

			$activeTab.stop(true, true).fadeIn(400).addClass("is-active");
		}

		function animateActive(index) {
			$droplets.each((i, el) => {
				const rot = getRotation(el);
				const isFirst = $(el).hasClass("is-first");

				const scale = i === index ? 1 : isFirst ? 1 : 0.75;

				gsap.to(el, {
					scale,
					rotation: rot,
					transformOrigin: "right bottom",
					duration: 0.5,
					ease: "power2.out",
				});

				const $first = $(el).find(".first");
				const $second = $(el).find(".second");
				const $overlay = $(el).find(".box");

				if (i === index) {
					gsap.to($first, { opacity: 1, duration: 0.4 });
					gsap.to($second, { opacity: 0, duration: 0.4 });
					gsap.to($overlay, { "--overlay-opacity": 0, duration: 0.4 });
				} else {
					gsap.to($first, { opacity: 0, duration: 0.4 });
					gsap.to($second, { opacity: 1, duration: 0.4 });

					if (!$(el).hasClass("is-first")) {
						gsap.to($overlay, { "--overlay-opacity": 1, duration: 0.4 });
					}
				}
			});
		}

		let currentRotation = 0;

		function rotateFlower(index) {
			const firstRot = getRotation($droplets[0]);
			const targetRot = getRotation($droplets[index]);

			let petalOffset = firstRot - targetRot;
			if (petalOffset < 0) petalOffset += 360;

			const base = Math.floor(currentRotation / 360) * 360;
			let next = base + petalOffset;

			if (next <= currentRotation) next += 360;

			currentRotation = next;

			applyFlowerPivot();

			gsap.to($flowerContainer[0], {
				rotation: currentRotation,
				transformOrigin: getFlowerPivot(),
				duration: 1,
				ease: "power3.inOut",
			});
		}

		function switchTab(index, rotate = true) {
			setActive(index);
			animateActive(index);
			if (rotate) rotateFlower(index);
		}

		function startAutoplay() {
			stopAutoplay();

			if (!isVisibleInViewport || document.hidden) return;

			autoplayTimer = setInterval(() => {
				$droplets.removeClass("is-first");

				const nextIndex =
					currentIndex === 0 ? $droplets.length - 1 : currentIndex - 1;

				switchTab(nextIndex, true);
				currentIndex = nextIndex;
			}, intervalTime);
		}

		function stopAutoplay() {
			if (autoplayTimer) {
				clearInterval(autoplayTimer);
				autoplayTimer = null;
			}
		}

		function introAnimation() {
			isAnimating = true;

			const tl = gsap.timeline({
				onComplete: () => {
					isAnimating = false;
					isIntroDone = true;
					$flowerContainer.addClass("is-interactive");
					switchTab(0, false);
					startAutoplay();
				},
			});

			$droplets.each((i, el) => {
				const rot = getRotation(el);
				const isFirst = $(el).hasClass("is-first");

				tl.to(
					el,
					{
						opacity: 1,
						scale: isFirst ? 1 : 0.75,
						rotation: rot,
						transformOrigin: "right bottom",
						duration: 1.8,
						ease: "power3.out",
					},
					i * 0.1,
				);

				tl.to(
					$(el).find(".img img"),
					{
						duration: 1.8,
						ease: "power3.out",
					},
					i * 0.1,
				);
			});
		}

		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					isVisibleInViewport = entry.isIntersecting;

					if (isVisibleInViewport) {
						if (!isIntroDone && !isAnimating) {
							introAnimation();
						} else if (isIntroDone) {
							startAutoplay();
						}
					} else {
						stopAutoplay();
					}
				});
			},
			{ threshold: 0.3 },
		);

		observer.observe($flowerContainer[0]);

		$(document).on("visibilitychange", () => {
			if (document.hidden) {
				stopAutoplay();
			} else if (isIntroDone) {
				startAutoplay();
			}
		});

		$droplets.on("mouseenter", function () {
			$(this).addClass("is-hover"); // ← separate hover class
			stopAutoplay();
		});

		$droplets.on("mouseleave", function () {
			$(this).removeClass("is-hover"); // ← remove hover class only
			startAutoplay();
		});
	},

	toggleFnc: () => {
		try {
			$(document).on(
				"click",
				".develope-section-id .petal-title",
				function (e) {
					e.preventDefault();

					const targetSelector = $(this).attr("href");
					const $target = $(targetSelector);

					if ($target.length) {
						$("html, body").animate(
							{
								scrollTop: $target.offset().top - $("header").outerHeight(),
							},
							600,
						);
					}
				},
			);
		} catch (error) {
			console.error(error);
		}

		$(".side-nav .menu-item-has-children > .title .icon").on(
			"click",
			function (e) {
				e.preventDefault();

				const $title = $(this).parent();
				const $li = $title.parent();
				const $siblings = $li.siblings(".menu-item-has-children");

				// Close siblings only
				$siblings.find("> .title").removeClass("is-active");
				$siblings.find("> .sub-menu").slideUp();

				// Toggle current
				$title.toggleClass("is-active");
				$title.next(".sub-menu").slideToggle();
			},
		);
	},

	scrollReveal: () => {
		if ($(window).width() > 1200.1) {
			// Function to process custom attributes
			function revealWithAttributes(selector, baseConfig) {
				document.querySelectorAll(selector).forEach((element) => {
					// Read custom attributes
					const delay = element.getAttribute("data-delay") || baseConfig.delay;
					const duration =
						element.getAttribute("data-duration") || baseConfig.duration;
					const distance =
						element.getAttribute("data-distance") || baseConfig.distance;

					// CRITICAL FIX: Find if this specific element lives inside your normal scroll container
					const scrollParent = element.closest(".normal-scroll-content");

					// Create a new configuration based on custom attributes
					const config = {
						...baseConfig,
						delay: parseInt(delay, 10),
						duration: parseInt(duration, 10),
						distance: distance,
						// If a scroll parent exists, force ScrollReveal to look inside it instead of 'window'
						...(scrollParent && { container: scrollParent }),
					};

					// Apply ScrollReveal
					ScrollReveal().reveal(element, {
						mobile: false,
						once: true,
						...config,
						easing: "cubic-bezier(0.5, 0, 0, 1)",
					});

					// Trigger animation for elements already in viewport
					const rect = element.getBoundingClientRect();
					if (rect.top < window.innerHeight && rect.bottom >= 0) {
						ScrollReveal().reveal(element, config);
					}
				});
			}

			// Base configurations
			let fadeDown = {
				origin: "top",
				duration: 1000,
				delay: 200,
				distance: "20px",
				interval: 50,
				reset: false,
			};
			let fadeUp = {
				origin: "bottom",
				duration: 1000,
				delay: 200,
				distance: "20px",
				interval: 50,
				reset: false,
			};
			let fadeLeft = {
				origin: "left",
				duration: 1000,
				delay: 200,
				distance: "25%",
				interval: 150,
				reset: false,
			};
			let fadeRight = {
				origin: "right",
				duration: 1000,
				delay: 200,
				distance: "25%",
				interval: 150,
				reset: false,
			};
			let fadeIn = {
				origin: "top",
				duration: 1100,
				delay: 220,
				distance: 0,
				interval: 150,
				reset: false,
			};

			// Call the function for each selector
			revealWithAttributes(".fd-down", fadeDown);
			revealWithAttributes(".fd-up", fadeUp);
			revealWithAttributes(".fd-left", fadeLeft);
			revealWithAttributes(".fd-right", fadeRight);
			revealWithAttributes(".fd-in", fadeIn);
		}
	},
	a11yUser: () => {
		const wrapForms = document.querySelectorAll(".wrap-form");
		wrapForms.forEach(function (form) {
			const submitInput = form.querySelector("input[type='submit']");
			const labelFor = submitInput.getAttribute("name");
			const labelSubmit = form.querySelector(".frm-btnwrap .label");
			if (labelFor !== null) {
				if (labelSubmit !== null) {
					labelSubmit.textContent = "Submit Button";
					labelSubmit.setAttribute("for", labelFor);
				}
			}
		});
	},
	hideElement: () => {
		if ($(window).width() < 1200.1) {
			$(".back-to-top").on("click", function (event) {
				event.preventDefault();
				$("html, body").animate({ scrollTop: 0 }, "300");
			});
			[".searchbox", ".nav-primary-menu"]
				.map((selector) => document.querySelector(selector))
				.forEach((el) => (el.style.display = "flex"));
		}
	},
	megaImage: () => {
		if ($(window).width() > 1200.1) {
			$(".menu-lv-3 .nav-link, .menu-lv-1 > .nav-link .head a").on("mouseenter", function () {
				let imageUrl = $(this).attr("data-img");
				let dataLink = $(this).attr("data-link");
				let dataTitle = $(this).attr("data-title");

				let imgWrap = $(".mega-menu .temp-product");
				let tempTitle = $(".temp-product .temp-title");

				imgWrap.addClass("active-panel");

				if (imageUrl) {
					imgWrap.find("img").attr("src", imageUrl);
				}

				if (dataLink) {
					imgWrap.find("a").attr("href", dataLink);
				}

				if (dataTitle) {
					tempTitle.text(dataTitle);
				}
			});

			$(".menu-lv-3 .nav-link, .menu-lv-1 > .nav-link .head a").on("mouseleave", function () {
				let imgWrap = $(".mega-menu .temp-product");

				imgWrap.removeClass("active-panel");
			});
		}
	},
	init: () => {
		generalFunction.svgVivus();
		generalFunction.scrollReveal();
		generalFunction.hideElement();
		generalFunction.gsapFlower();
		generalFunction.toggleFnc();
		generalFunction.megaImage();
		initRadialFeature();
	},
};

function fullPageInit() {
	try {
		const headerHeight = $("#header").outerHeight();
		if (!$("#fullpage").length) return;

		let arrayAnchor = ["fp-block-1", "fp-block-2", "fp-block-3", "fp-block-4"];

		var myFullpage = new fullpage("#fullpage", {
			bigSectionsDestination: null,
			menu: "#header,#menu-parallax",
			lockAnchors: false,

			fixedElements: "#header,.sidenav-group",

			anchors: arrayAnchor,
			navigationTooltips: arrayAnchor,

			normalScrollElements:
				".scrollbar-wrap,.popup-modal,.normal-scroll,.menu-lv-3",
			scrollOverflow: true,
			slidesNavigation: true,
			slidesNavPosition: "bottom",
			showActiveTooltip: true,
			easingcss3: "cubic-bezier(0.645, 0.045, 0.355, 1.000)",
			// Scrolling
			css3: true,
			offsetSections: true,
			scrollingSpeed: 800,
			touchSensitivity: 10,
			autoScrolling: true,
			fitToSection: true,

			paddingTop: headerHeight,
			fitToSectionDelay: 400,
			scrollBar: false,
			easing: "easeInOutCubic",
			easingcss3: "ease",
			loopBottom: false,
			loopTop: false,
			loopHorizontal: true,
			continuousHorizontal: true,
			scrollHorizontally: true,
			continuousVertical: false,
			touchSensitivity: 15,
			normalScrollElementTouchThreshold: 5,

			// Accessibility
			keyboardScrolling: true,
			animateAnchor: true,
			recordHistory: true,

			// Design
			controlArrows: true,
			verticalCentered: true,
			resize: false,

			responsiveWidth: 0,
			responsiveHeight: 0,

			// Custom selectors
			sectionSelector: "section",

			dragAndMove: true,

			afterRender: function () {
				$("body").addClass("body-has-fp");
				window.fpScrollDebug(
					"debug ON — hard-flick branding → watch onLeave",
					{
						indexes: "0 banner, 1 branding, 2 develope, 3 last",
						theoryStacked: "onLeave.theoryStacked true = two snaps < 800ms",
						theorySkippedDevelope:
							"onLeave 1→3 = skipped develope",
						theoryLeftoverInactive:
							"wheel on INACTIVE develope = ticks during the snap",
						theoryLeftoverLock:
							"swallowed by lock = inertia after landing",
						off: "window.DEBUG_FP_SCROLL = false",
					},
				);
			},

			onSlideLeave: function () {
				$("section [data-aos]").removeClass("aos-animate");
			},

			afterSlideLoad: function () {
				$("section.active [data-aos]").addClass("aos-animate");
			},

			onLeave: function (origin, destination, direction) {
				const now = Date.now();
				const sinceLast = window._fpScrollDebug.lastLeaveAt
					? now - window._fpScrollDebug.lastLeaveAt
					: null;
				window.fpScrollDebug("onLeave", {
					from: origin.index,
					to: destination.index,
					direction,
					sinceLastMs: sinceLast,
					lockLeftMs: Math.max(
						0,
						(window._developeWheelLockUntil || 0) - now,
					),
					wheelsSinceLastLeave: { ...window._fpScrollDebug.wheels },
					theoryStacked: sinceLast !== null && sinceLast < 800,
					theorySkippedDevelope:
						origin.index === 1 && destination.index === 3,
				});
				window._fpScrollDebug.wheels = {
					inactive: 0,
					locked: 0,
					delay: 0,
					leaveDown: 0,
					leaveUp: 0,
					scrub: 0,
				};
				window._fpScrollDebug.lastLeaveAt = now;

				$("section [data-aos]").removeClass("aos-animate");

				$(".sidenav-group").toggleClass("is-visible", destination.index !== 0);

				// --- ADDED LOGIC ---
				// Adds 'minimize' if destination is NOT the first section (index 0)
				// Removes 'minimize' when returning to the first section
				$("body").toggleClass("minimize", destination.index !== 0);

				// Stamp a wheel cooldown when heading to develope.
				// Do not call setAllowScrolling here — that aborts the
				// current snap and leftover ticks skip to the next section.
				if (destination.index === 2) {
					window._developeWheelLockUntil = Date.now() + 1000;
					window.fpScrollDebug("lock stamped onLeave → develope", {
						until: window._developeWheelLockUntil,
					});
				}
			},

			afterLoad: function (origin, destination, direction) {
				window.fpScrollDebug("afterLoad", {
					from: origin ? origin.index : null,
					to: destination.index,
					direction,
					lockLeftMs: Math.max(
						0,
						(window._developeWheelLockUntil || 0) - Date.now(),
					),
					wheelsDuringSnap: { ...window._fpScrollDebug.wheels },
				});

				$("section.active [data-aos]").addClass("aos-animate");

				$("body").toggleClass("minimize", destination.index !== 0);

				// Re-lock fullPage when entering fp-block-3 (index 2)
				// so the Swiper wheel handler takes control again
				if (destination.index === 2) {
					fullpage_api.setAllowScrolling(false);
					window._developeWheelLockUntil = Date.now() + 1000;
					window.fpScrollDebug("landed develope, scrolling locked", {
						until: window._developeWheelLockUntil,
					});
					// Reset swiper to first slide so scroll-up works correctly
					if (direction === "down" && window.homeDevelopeSwiper) {
						window.homeDevelopeSwiper.slideTo(0, 0); // jump to first slide instantly
					}
				} else {
					// Re-enable scrolling for all other sections
					fullpage_api.setAllowScrolling(true);
					window._developeWheelLockUntil = 0;
				}
				if (destination.index === 3) {
					setTimeout(() => {
						if (typeof ScrollReveal !== "undefined") {
							ScrollReveal().delegate();
						}

						// Also manually check elements whose top is within the container viewport
						const container = destination.item.querySelector(
							".normal-scroll-content",
						);
						if (container) {
							const containerRect = container.getBoundingClientRect();
							container
								.querySelectorAll(
									".fd-down, .fd-up, .fd-left, .fd-right, .fd-in",
								)
								.forEach((el) => {
									const elRect = el.getBoundingClientRect();
									// If element is already visible within the container's visible area
									if (
										elRect.top < containerRect.bottom &&
										elRect.bottom > containerRect.top
									) {
										el.style.visibility = "visible";
										el.style.opacity = "1";
										el.style.transform = "none";
										el.style.transition = "opacity 1s ease, transform 1s ease";
									}
								});
						}
					}, 650); // Wait for fullPage transition (scrollingSpeed: 600) to finish
				}
			},
		});

		// Define a variable outside the event to track the last time fullPage moved
		let lastFpScrollTime = 0;

		$(".normal-scroll-content").on("wheel", function (e) {
			const now = Date.now();

			if (now - lastFpScrollTime < 1000) {
				var currentScrollTop = $(this).scrollTop();
				var delta = e.originalEvent.deltaY;
				if (
					(delta < 0 && currentScrollTop <= 0) ||
					(delta > 0 &&
						currentScrollTop >= this.scrollHeight - $(this).innerHeight())
				) {
					e.preventDefault();
				}
				return;
			}

			var delta = e.originalEvent.deltaY;
			var currentScrollTop = $(this).scrollTop();
			var maxScrollTop = this.scrollHeight - $(this).innerHeight();

			if (delta < 0 && currentScrollTop <= 0) {
				e.preventDefault();
				lastFpScrollTime = now;
				fullpage_api.moveSectionUp();
			} else if (delta > 0 && currentScrollTop >= maxScrollTop) {
				e.preventDefault();
				lastFpScrollTime = now;
				fullpage_api.moveSectionDown();
			}
		});
		$(".back-to-top").on("click", function (event) {
			event.preventDefault();

			// --- NEW FIX ---
			// Force reset the normal scroll container instantly on click
			$(".normal-scroll-content").scrollTop(0);

			if (typeof fullpage_api !== "undefined") {
				fullpage_api.moveTo(1);
			} else {
				$("html, body").animate({ scrollTop: 0 }, 300);
			}
		});
	} catch (error) {
		console.log(error);
	}
}

function aosInit() {
	AOS.init({
		// Global settings:

		disable: window.innerWidth < 1200,
		startEvent: "load", // name of the event dispatched on the document, that AOS should initialize on
		initClassName: "aos-init", // class applied after initialization
		animatedClassName: "aos-animate", // class applied on animation
		useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
		disableMutationObserver: false, // disables automatic mutations' detections (advanced)
		debounceDelay: 20, // the delay on debounce used while resizing window (advanced)
		throttleDelay: 0, // the delay on throttle used while scrolling the page (advanced)
		// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
		offset: 120, // offset (in px) from the original trigger point
		delay: 120, // values from 0 to 3000, with step 50ms
		duration: 500, // values from 0 to 3000, with step 50ms
		easing: "ease-in-out-back", // default easing for AOS animations
		once: true,
		mirror: true, // whether elements should animate out while scrolling past them
		anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
	});
}

function mappingFunc() {
	new MappingListener({
		selector: ".product-side-nav",
		mobileWrapper: ".mobile-filter-wrap .fitler-wrap",
		mobileMethod: "insertBefore",
		desktopWrapper: ".desktop-filter-toggle",
		desktopMethod: "insertBefore",
		breakpoint: 1200.1,
	}).watch();
}
